import { SuperAdminService } from "services/superAdminService";

class AllahNames extends SuperAdminService<any> {
  constructor() {
    super("allah-names");
  }
}
export default new AllahNames();
